import script from "./DeadlineChartTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DeadlineChartTable.vue?vue&type=script&setup=true&lang=js"

import "./DeadlineChartTable.vue?vue&type=style&index=0&id=d487cde4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\Code\\GK\\MulticaseWeb\\MulticaseWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d487cde4"]])

export default __exports__